// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mu-1";
export var messageSideRight = "_mu-2";
export var subscribeToBackInStockBubbleContainer = "_mu-0";